import React from 'react';
import Dashboard from '@mui/icons-material/Dashboard';
import Assignment from '@mui/icons-material/Assignment';
import Settings from '@mui/icons-material/Settings';
import InsertChart from '@mui/icons-material/InsertChart';

const menuItems = [
  {
    icon: <Dashboard />,
    text: 'NavBar.Dashboard',
    path: '/dashboard',
    name: 'Dashboard',
    roles: ['Administrator', 'Customer']
  },
  {
    icon: <Assignment />,
    text: 'NavBar.Offers',
    path: '/offers',
    name: 'Offers',
    roles: ['Administrator', 'Customer']
  },
  // { icon: <Assignment />, text: 'NavBar.Applications', path: '/applications', name: 'Applications', roles: ['Administrator', 'Customer'] },
  {
    icon: <InsertChart />,
    text: 'NavBar.Reports',
    path: '/reports',
    name: 'Reports',
    roles: ['Administrator', 'Customer']
  },
  {
    icon: <Settings />,
    text: 'NavBar.Settings',
    path: '/settings',
    name: 'Settings',
    roles: ['Administrator', 'Customer']
  }
  // { icon: <List />, text: "NavBar.LSNGAPP", path: "/external/env/REACT_APP_LSNG", name: "Lsng App", roles: ["Administrator", "Customer"] },
  // { icon: <List />, text: "NavBar.GoogleCom", path: "/external/https:/www.google.com", name: "Google.com", roles: ["Administrator", "Customer"] }
];

export default menuItems;
